export const UPDATE_EV_STATE = 'UPDATE_EV_STATE'
export const EV_CREATED = 'EV_CREATED'
export const EV_DELETED = 'EV_DELETED'
export const EV_UPDATED = 'EV_UPDATED'
